/**
 * Servicio mock de consulta SII.
 *
 * Futuro:
 * React → Supabase/backend → agente Playwright en PC de oficina → Portal MiPyme SII
 *
 * Por ahora no realiza solicitudes reales.
 */
export const siiService = {
	/**
	 * @param {string} rut
	 * @returns {Promise<object|null>}
	 */
	async consultarContribuyente(rut) {
		// MOCK: no consultar el SII en esta etapa.
		void rut;
		return null;
	},

	/**
	 * Simulación opcional con datos ficticios (claramente marcada como mock).
	 * No debe usarse como fuente real.
	 */
	async consultarContribuyenteMock(rut) {
		await new Promise((resolve) => setTimeout(resolve, 400));
		return {
			rut,
			nombre: "Cliente Simulado SpA",
			giro: "Actividades de consultoría de gestión",
			domicilio: "Av. Ejemplo 100, Oficina 101",
			comuna: "Santiago",
			correo: "",
			telefono: "",
			_mock: true,
			mensaje: "Datos simulados. La consulta real al SII estará disponible en una próxima etapa.",
		};
	},
};
